const options = {
  currency: [
    { label: "$", value: "dollar" },
    { label: "₹", value: "rupee" }
  ],
  typeOfRequest: [
    { label: "Initial", value: "initial" },
    { label: "Production", value: "production" },
    { label: "Product", value: "product" }
  ],
  processTypeoptions: [
    {
      label: "Sample",
      value: "sample"
    },
    {
      label: "Garment Tech",
      value: "garmentTechnologist"
    },
    {
      label: "3D",
      value: "cad"
    },
    {
      label: "Fabric",
      value: "fabric"
    },
    {
      label: "Trim",
      value: "trim"
    },
    {
      label: "Pattern",
      value: "pattern"
    },
    {
      label: "Cutting",
      value: "cutting"
    },
    {
      label: "Sewing",
      value: "sewing"
    },
    {
      label: "Embellishment",
      value: "embellishment"
    },
    {
      label: "Embroidery",
      value: "embroidery"
    },
    {
      label: "Wash",
      value: "wash"
    },
    {
      label: "Dispatch",
      value: "dispatch"
    },
    {
      label: "Grading",
      value: "qc"
    },
    {
      label: "Marker",
      value: "marker"
    },
    {
      label: "Costing",
      value: "costing"
    },
    {
      label: "SignOff",
      value: "signOff"
    }
  ]
};

const tableHeader = {
  //meetingNOtes
  meetingNoteTable: [
    { tableName: "MN ID", tableKeyName: "MNId" },
    { tableName: "Customer-Dept", tableKeyName: "customerAndDepartmentName" },
    { tableName: "Date of Meeting", tableKeyName: "dateOfMeeting" },
    { tableName: "Place of Meeting", tableKeyName: "placeOfMeeting" }
  ],

  //customer
  customerTable: [
    { tableName: "Customer Code", tableKeyName: "customerCode" },
    { tableName: "Customer Name", tableKeyName: "customerName" },
    { tableName: "Status", tableKeyName: "customerStatus" }
  ],

  //fabric
  fabricTable: [
    { tableName: "Fabric No", tableKeyName: "fabricNumber" },
    { tableName: "Dev ref no", tableKeyName: "devRefNumber" },
    { tableName: "Count & Construction", tableKeyName: "count & construction" },
    { tableName: "Quality", tableKeyName: "quality" },
    { tableName: "Classification", tableKeyName: "classificationOfFabric" },
    { tableName: "Supplier Name", tableKeyName: "supplierName" },
    { tableName: "Price ", tableKeyName: "price" }
  ],
  //cad
  cadTable: [
    { tableName: "Customer - Dept", tableKeyName: "customerAndDepartmentName" },
    { tableName: "Style No.", tableKeyName: "magnumStyleId" },
    { tableName: "3D Type", tableKeyName: "cadType" },
    { tableName: "3D name", tableKeyName: "cadName" },
    { tableName: "Category", tableKeyName: "category" },
    { tableName: "Print Type", tableKeyName: "printType" },
    { tableName: "Story Name", tableKeyName: "storyName" }
  ],
  //style
  styleTable: [
    { tableName: "Style No / Ref", tableKeyName: "styleNo" },
    { tableName: "Style name", tableKeyName: "styleName" },
    { tableName: "Cust ref no", tableKeyName: "custRefNo" },
    { tableName: "Item no", tableKeyName: "itemNo" },
    { tableName: "Cust-Dept", tableKeyName: "cust_Dept" },
    { tableName: "Garment type", tableKeyName: "garmentType" },
    { tableName: "Fabric type", tableKeyName: "fabricType" }
  ],
  smvTable: [
    { tableName: "SMV No.", tableKeyName: "smvNumber" },
    { tableName: "Style No/Ref", tableKeyName: "styleNo" },
    { tableName: "Style name", tableKeyName: "styleName" },
    { tableName: "Cust-Dept", tableKeyName: "customer" },
    { tableName: "Total SAM", tableKeyName: "totalSam" },
    { tableName: "Total Thread", tableKeyName: "totalVal" }
  ],
  tiTable: [
    { tableName: "Issue.No", tableKeyName: "issueNumber" },
    { tableName: "Date", tableKeyName: "date" },
    { tableName: "Style No/Ref", tableKeyName: "styleNo" },
    { tableName: "Style name", tableKeyName: "styleName" },
    { tableName: "Cust-Dept", tableKeyName: "customer" }
  ],
  //trim
  trimTable: [
    { tableName: "Trim No", tableKeyName: "trimNumber" },
    { tableName: "Category", tableKeyName: "trimCategory" },
    { tableName: "Description", tableKeyName: "description" },
    { tableName: "Supplier ref no", tableKeyName: "supplierRef" },
    { tableName: "Supplier", tableKeyName: "supplierName" },
    { tableName: "Price", tableKeyName: "price" },
    { tableName: "Size", tableKeyName: "sizeNumber" }
  ],

  //sourcing
  sourcingTable: [
    { tableName: "Sourcing No", tableKeyName: "sourcingNumber" },
    { tableName: "Meeting No", tableKeyName: "MNID" },
    {
      tableName: "Origination Of Request",
      tableKeyName: "originationOfRequest"
    },
    { tableName: "Supplier ref no", tableKeyName: "supplierRefId" },
    { tableName: "season", tableKeyName: "season" },
    { tableName: "Measurement", tableKeyName: "measurement" }
  ],

  //sampleRequest
  samplerequestTable: [
    { tableName: "SR No.", tableKeyName: "requestNumber" },
    { tableName: "Date of Req.", tableKeyName: "createdAt" },
    { tableName: "Style No.", tableKeyName: "styleNumber" },
    { tableName: "Style Name", tableKeyName: "styleName" },
    { tableName: "Cust-Dept", tableKeyName: "customerName" },
    { tableName: "Cust Ref no", tableKeyName: "customerId" },
    { tableName: "Source of Req.", tableKeyName: "typeOfRequest" },
    { tableName: "Sample Type", tableKeyName: "sampleType" }
  ],

  //systemSupplier
  systemSupplierTable: [
    { tableName: "Supplier Code", tableKeyName: "supplierCode" },
    { tableName: "Supplier Name", tableKeyName: "supplierName" },
    { tableName: "Status", tableKeyName: "supplierStatus" }
  ],

  // print fabric list

  fabricPrintTable: [
    { tableName: "FABRIC NO", tableKeyName: "fabricNumber" },
    { tableName: "SUPPLIER", tableKeyName: "supplierName" },
    { tableName: "SUPP REF NO", tableKeyName: "supplierRefNo" },
    { tableName: "COUNT", tableKeyName: "count" },
    { tableName: "CONSTRUCTION", tableKeyName: "construction" },
    { tableName: "QUALITY", tableKeyName: "quality" },
    { tableName: "COMPOSITION", tableKeyName: "composition" },
    { tableName: "GSM / WIDTH", tableKeyName: "gsm" },
    { tableName: "QTY RCVD", tableKeyName: "quantityReceived" }
  ],

  stylePrintTable: [
    { tableName: "DATE", tableKeyName: "date" },
    { tableName: "MAGNUM STYLE NO", tableKeyName: "styleNo" },
    { tableName: "STYLE NAME", tableKeyName: "styleName" },
    // { tableName: "TYPE", tableKeyName: "type" },
    { tableName: "SAMPLE TYPE", tableKeyName: "sampleType" },
    { tableName: "FABRIC", tableKeyName: "fabric" },
    // {tableName:"FABRIC NAME",tableKeyName:"fabricName"},
    // {tableName:"BASE NO",tableKeyName:"bNumber"},
    // { tableName: "FABRIC ORIGIN", tableKeyName: "fabricOrigination" },
    { tableName: "SIZE", tableKeyName: "size" },
    { tableName: "WASH TYPE", tableKeyName: "washType" },
    { tableName: "CUSTOMER", tableKeyName: "customer" },
    // { tableName: "CUST REF NO / ITEM NO", tableKeyName: "cusRefItemNum" }
    { tableName: "CUST REF NO ", tableKeyName: "cusRef" },
    { tableName: "CUST ITEM NO", tableKeyName: "ItemNum" }
  ],

  bnoTable: [
    { tableName: "B NO", tableKeyName: "baseRefNumber" },
    { tableName: "F NO", tableKeyName: "fabricNumber" },
    { tableName: "COUNT & CONSTRUCTION ", tableKeyName: "countConstruction" },
    { tableName: "QUALITY", tableKeyName: "qualityName" },
    { tableName: "CLASSIFICATION", tableKeyName: "classificationOfFabric" },
    { tableName: "GREIGE MILL", tableKeyName: "greigeMill" },
    { tableName: "PROCESS MILL", tableKeyName: "processMill" }
  ],

  costingTable: [
    { tableName: "Costing Id", tableKeyName: "costingNumber" },
    { tableName: "Created On", tableKeyName: "orderDate" },
    { tableName: "SR No.", tableKeyName: "sampleReqNo" },
    { tableName: "Style No/Ref", tableKeyName: "styleRefNumber" },
    { tableName: "Style name ", tableKeyName: "magnumStyleName" },
    { tableName: "Cust-Dept", tableKeyName: "custDept" },
    { tableName: "Costing Type", tableKeyName: "costingType" },
    { tableName: "Total Cost (₹​)", tableKeyName: "totalCost" },
    { tableName: "Price", tableKeyName: "otherCost" }
  ],

  IBTable: [
    { tableName: "Heading", tableKeyName: "value" },
    { tableName: "Heading", tableKeyName: "value" },
    { tableName: "Heading", tableKeyName: "value" }
  ],

  employeeTable: [
    { tableName: "User ID", tableKeyName: "userId" },
    { tableName: "Name", tableKeyName: "employeeName" },
    { tableName: "Role ", tableKeyName: "roleName" },
    { tableName: "Rights ", tableKeyName: "RIGHTS" }
  ],

  roleTable: [
    { tableName: "Role Name", tableKeyName: "roleName" },
    { tableName: "Rights", tableKeyName: "RIGHTS" }
  ]
};
const roleFilter = [
  { moduleName: "MEETINGROOM", rightsName: "meetingNotes" },
  { moduleName: "CAD", rightsName: "cad" },
  { moduleName: "FABRIC", rightsName: "fabric.fabric" },
  { moduleName: "BNUMBER", rightsName: "bNumber" },
  { moduleName: "TRIM", rightsName: "trim.trim" },
  { moduleName: "SOURCING", rightsName: "sourcing" },
  { moduleName: "STYLE", rightsName: "style" },
  { moduleName: "SAMPLEREQUEST", rightsName: "sampleRequest.sampleRequest" },
  { moduleName: "COSTING", rightsName: "costing" },
  { moduleName: "SYSTEMSUPPLIER", rightsName: "system" },
  { moduleName: "CUSTOMER", rightsName: "customer.customer" },
  { moduleName: "EMPLOYEE", rightsName: "permissions.employeeDetails" },
  { moduleName: "ROLE", rightsName: "permissions.roleManagement" },
  { moduleName: "SMVTHREAD", rightsName: "smvCalcThread" },
  { moduleName: "TECHNICALISSUES", rightsName: "technicalIssues" }
];
export { tableHeader, roleFilter };
export default options;


// WEBPACK FOOTER //
// ./src/services/common/options.js